<template lang="pug">
#betlistModal.modal
  .modal-dialog
    .modal-content
      .modal-body.tournament-betlist
        .tournament-betlist-header
          .tournament-betlist.d-flex.justify-content-between.align-items-center
            .bet-title
              i.fad.fa-list.mr-1
              span {{ $t('ui.bet_list') }}
            span {{ $t('ui.room_id') }}: {{ roomId }}
            .tournament-close
              a(href='#' data-dismiss='modal' aria-label='Close')
                i.fas.fa-times
        .tournament-betlist-content
          template(v-if="betList == 'undefined' || betList.length <= 0")
            .betlist-wrapper
              .betlist-body
                .betlist-event.text-center.pt-5.pb-5
                  b {{ $t('message.no_information_available') }}
          template(v-for="(item, index) in betList")
            .betlist-wrapper
              .betlist-header
                .d-flex.justify-content-between
                  div {{ $t("ui.no/") }} {{ index + 1 }}
                  .id-no ID: {{ item.bet_id }}
                  .status {{ $t("ui." + item.bet_status.toLowerCase()) }}
              .betlist-body
                .betlist-bettype {{ sports[item.sports_type] }} - {{ $tc("m.BT_" + item.bet_type, 1) }}
                .betlist-trans-time.d-flex.justify-content-between
                  div {{ $t("ui.trans_time") }}
                  div {{ $dayjs(item.created_on).format("MM/DD/YYYY hh:mm:ss A") }}
                .betlist-event.text-center
                  .betlist-league {{ item.league_name }}
                  .betlist-match.d-flex
                    .betlist-match-home {{ item.home_team_name }} 
                    .betlist-match-vs -vs-
                    .betlist-match-away {{ item.away_team_name }}
                  .betlist-match-date {{ $dayjs(item.match_time).format("MM/DD/YYYY HH:mm A") }}
                .d-flex.justify-content-between
                  span {{ $t("ui.bet") }}:
                  span
                    template(v-if="['HDP','HDPH'].includes(item.bet_type)")
                      template(v-if="item.home_away === 1") 
                        | {{ getTeamName("home", item) }}
                      template(v-else) 
                        | {{ item.away_team_name }} 
                    template(v-else)
                      template(v-if="item.home_away === 1") 
                        | {{ $t('ui.over') }}
                      template(v-else) 
                        | {{ $t('ui.under') }} 
                    | &nbsp;{{ item.ball_display }} @ {{ item.odds_display }}
                .d-flex.justify-content-between
                  span {{ $t("ui.stake") }}:
                  span {{ $numeral(item.bet_member).format("0,0") }}
                .d-flex.justify-content-between
                  span {{ $t("ui.players") }}:
                  span {{ item.member_id }}

</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";
import vPagination from "vue-plain-pagination";

export default {
  components: {},
  props: {},
  data() {
    return {
      roomId: null,
      betList: [],
    };
  },
  computed: {
    sports() {
      return this.$store.state.layout.sports;
    },
    language() {
      return this.$store.getters.language;
    },
  },
  mounted() {
    EventBus.$on("ROOM_BETLIST", this.show);
  },
  destroyed() {
    EventBus.$off("ROOM_BETLIST", this.show);
  },
  methods: {
    show(e) {
      this.roomId = e.room_id;
      this.betList = e.data;
      $("#betlistModal").modal("show");
    },
    getTeamName(p, e) {
      var name = e[p + "_name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "_team_name"];
      }
      return name;
    },
  },
};
</script>
